import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-invite-guest',
  templateUrl: './invite-guest.component.html',
  styleUrls: ['./invite-guest.component.scss'],
})
export class InviteGuestComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
